module.exports = __webpack_public_path__ + "img/Report.5d7f712c.png";